<template>
  <div>
    <div class="news-page page">
      <!-- 顶部1 -->
      <page-top></page-top>
      <!-- 头部 -->
      <Header></Header>
      <!-- 主体 -->
      <main class="main">
        <section class="breadcrumb-plate w">
          <div class="label">当前位置：</div>
          <breadcrumb />
        </section>
        <section class="content w">
          <div class="c-left">
            <tabbar
              :tabData="tabList"
              :code="categoryId"
              :seccode="seccode"
              @changeSecTab="changeSecTab"
            ></tabbar>
          </div>

          <div class="c-right">
            <div class="content">
              <a
                class="coop-item"
                v-for="(item, index) in coopList"
                :key="index"
                :href="item.unitUrl"
                target="_blank"
              >
                <img class="img" :src="item.unitLogo" alt="" />
              </a>
            </div>
          </div>
        </section>
      </main>
      <!-- 底部 -->
      <Footer></Footer>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import pageTop from "@/components/common/pageTop.vue";
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";
import Tabbar from "@/components/list/tabbar.vue";

import Breadcrumb from "@/components/common/breadcrumb";
import { getCooperateUnitPage } from "@/api/home/home.js";
import { getNavItemByCode } from "@/api/common/common.js";

export default {
  components: { pageTop, Header, Footer, Tabbar, Breadcrumb },
  data() {
    return {
      tabList: [],
      tabTitle: "新闻中心",
      coopList: [],
      categoryId: "",
      tabcode: "",
      seccode: "",
    };
  },
  mounted() {
    this.categoryId = this.$route.query?.categoryId;
    this.tabcode = this.$route.query?.tabcode;
    this.seccode = this.$route.query?.seccode;
    this.fetchData();
  },
  methods: {
    //统一获取数据
    fetchData() {
      if (!this.tabcode) return;
      getNavItemByCode(this.tabcode).then((res) => {
        if (!res.data) return;
        this.tabList = res.data[0];
        if(this.tabList.list && this.tabList.list.length) {
          this.categoryId = this.categoryId == this.tabcode?this.tabList.list[0].categoryCode:this.categoryId 
          this.cooperateUnitPage();

        }
      });
    },
    // 合作信息
    cooperateUnitPage() {
      console.log(" this.categoryId", this.categoryId,this.tabList);
      let params = {
        coopType: this.categoryId,
      };
      getCooperateUnitPage(params).then((res) => {
        if (!res.data) return;
        this.coopList = res.data;
      });
    },
    changeSecTab(item) {
      let coopUrl =
        "/cooperateUnit/list?categoryId=" +
        item.categoryCode +
        "&linkType=" +
        item.linkType +
        "&tabcode=801";

      window.location.href = coopUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.news-page {
  .main {
    flex: 1;
    padding-bottom: 80px;
    background-color: #fff;

    .breadcrumb-plate {
      display: flex;
      align-items: center;
      padding: 16px 0;

      .label {
        line-height: 1;
        font-size: 14px;
      }

      .el-breadcrumb {
        cursor: pointer;

        /deep/ .el-breadcrumb__inner.is-link {
          font-weight: normal;
        }
      }
    }

    .content {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      .c-left {
        width: 270px;
        flex-shrink: 0;

        margin-right: 15px;
        background-color: #fff;
        // box-shadow: 0 2px 2px rgba($color: #000000, $alpha: 0.05);
        box-shadow: 0px 2px 2px #edeef0;
      }

      .c-right {
        flex: 1;
        box-shadow: 0px 2px 2px #edeef0;

        .content {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;

          .coop-item {
            width: 25%;
            height: 94px;
            padding: 10px;
            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(237, 237, 237);
            }
          }
        }
      }
    }
  }
}
</style>
